import { render, staticRenderFns } from "./breadcrumbLink.vue?vue&type=template&id=8593ecbe&scoped=true&"
import script from "./breadcrumbLink.vue?vue&type=script&lang=js&"
export * from "./breadcrumbLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8593ecbe",
  null
  
)

export default component.exports